import type { ReactElement } from "react";

import { PlainTooltip } from "@similarweb/ui-components";

import type { ListIconButtonProps } from "./ListIconButton";
import ListIconButton from "./ListIconButton";

type ListIconButtonContainerProps = ListIconButtonProps & {
    tooltipContent?: ReactElement;
    buttonText?: string | number;
};

const ListIconButtonTooltipContainer = (props: ListIconButtonContainerProps) => {
    const { tooltipContent, ...rest } = props;

    if (!tooltipContent) {
        return (
            <div>
                <ListIconButton {...rest} />
            </div>
        );
    }

    return (
        <PlainTooltip
            placement="bottom"
            enabled={!props.isDisabled}
            cssClass="PlainTooltip-element PlainTooltip-element--header"
            tooltipContent={tooltipContent}
        >
            <div>
                <ListIconButton {...rest} />
            </div>
        </PlainTooltip>
    );
};

export default ListIconButtonTooltipContainer;
